import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=8fdf7462"
import script from "./assistant.vue?vue&type=script&lang=ts"
export * from "./assistant.vue?vue&type=script&lang=ts"
import style0 from "./assistant.vue?vue&type=style&index=0&id=8fdf7462&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports